import Icon1 from "public/marketplace-apps/Icon1.png";
import Icon2 from "public/marketplace-apps/Icon2.png";
import Icon3 from "public/marketplace-apps/Icon3.png";
import Icon4 from "public/marketplace-apps/Icon4.png";

export const LIST_CONSTANTS = {
  heading: "Why List on AppSpace?",
  items: [
    {
      image: Icon1,
      label: "Greater visibility in our network",
      text: "Get discovered by thousands of developers, teams, and enterprises actively exploring new tools and services across our platform.",
    },
    {
      image: Icon3,
      label: "Promotion in active campaigns",
      text: "Your app may be featured in curated collections, newsletter campaigns, and seasonal promotions run by AppSpace to boost adoption.",
    },
    {
      image: Icon2,
      label: "Built-in analytics & support",
      text: "Access real-time performance metrics, user behavior data, and dedicated partner support to help you optimize and grow.",
    },
    {
      image: Icon4,
      label: "Aligned with social impact goals",
      text: "We prioritize apps that support sustainability, accessibility, and ethical tech—ensuring you're seen by like-minded users and orgs.",
    },
    {
      image: Icon1,
      label: "Seamless ecosystem integration",
      text: "Easily connect with other services in the AppSpace ecosystem—authentication, billing, support, and scaling are pre-integrated.",
    },
    {
      image: Icon2,
      label: "Trusted by purpose-driven teams",
      text: "AppSpace is home to a curated marketplace used by fast-scaling startups and impact-focused enterprises that value quality.",
    },
  ],
};

export const FOOTER_CONSTANTS = {
  heading: "Ready to Share Your Vision?",
  text: "Join a growing ecosystem of innovators and builders. List your product, reach thousands of users, and grow with a platform designed to spotlight your impact.",
  btn: {
    label: "Become a vendor",
    link: "contact-us",
  },
};
